export default __webpack_public_path__ + "static/media/ami2.9dd4a59e.jpg";